import React from "react";
import CalendarWeekComponent from "../../dashboard/calendar/CalendarWeekComponent";
import WeekDay from "./components/WeekDay";

const CalendarWeek = (props, { locals }) => {
  const {
    activeWeek,
    endOfWeek,
    query,
    workoutNotes,
    workoutCoachNotes,
    activeUser,
    dailyStats,
  } = locals;

  return (
    <CalendarWeekComponent
      activeWeek={activeWeek}
      endOfWeek={endOfWeek}
      query={query}
      workoutNotes={workoutNotes}
      workoutCoachNotes={workoutCoachNotes}
      activeUser={activeUser}
      WeekDay={WeekDay}
      dailyStats={dailyStats}
    />
  );
};

export default CalendarWeek;
